const toQueryString = params => {
  const str = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return str ? `?${str}` : '';
};

export default toQueryString;